// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import TopHeader from '../../components/common/topHeader';
import Collection from '../../components/pages/myCollection/Collection';
import { useAppDispatch } from '../../store';
import { hideLoading, showLoading } from '../../store/features/loadingPage';
import './index.scss';
import Pagination from '../../components/common/pagination';
import useMessage from '../../components/common/toast/UseMessage';
import { LotteryApis } from '../../services/lotteryDetail';
import ScrollButton from '../../components/pages/top/backToTop/ScrollButton';
import { listsErrorNotShowToast } from '../../constants';

function ListLottery() {
  const { openMessageError } = useMessage();

  const dispatch = useAppDispatch();
  const [dataCollection, setDataCollection] = useState();
  const [page, setPage] = useState(1);

  const history = useHistory();

  const TABS = { TAB_LOTTERY_NOW: 'now', TAB_LOTTERY_SOON: 'soon', TAB_LOTTERY_END: 'end' };
  const [status, setStatus] = useState(TABS.TAB_LOTTERY_NOW);

  const handleChangePage = (page) => {
    window.scrollTo(0, 0);
    setPage(page);
  };

  const totalPage = Math.ceil(dataCollection?.total / dataCollection?.per_page);

  const getLotteryList = async () => {
    dispatch(showLoading());
    try {
      const res = await LotteryApis.getList({ page, status });
      const { data } = res;
      setDataCollection(data);
    } catch (error) {
      if (!listsErrorNotShowToast.includes(Number(error?.response?.status))) {
        openMessageError(error);
      }
    } finally {
      dispatch(hideLoading());
    }
  };

  useEffect(() => {
    getLotteryList();
  }, [page, status]);

  return (
    <>
      {dataCollection && (
        <>
          <TopHeader title="くじ一覧" />
          <>
            <div className="main-content list-lottery">
              <div className="tabs">
                <div
                  className={`tab-lottery ${
                    status === TABS.TAB_LOTTERY_NOW && 'tab-lottery-active'
                  }`}
                  onClick={() => {
                    setStatus(TABS.TAB_LOTTERY_NOW);
                    setPage(1);
                  }}
                  value={TABS.TAB_LOTTERY_NOW}
                  name="TAB_LOTTERY_NOW"
                >
                  販売中
                </div>
                <div
                  className={`tab-lottery ${
                    status === TABS.TAB_LOTTERY_SOON && 'tab-lottery-active'
                  }`}
                  onClick={() => {
                    setStatus(TABS.TAB_LOTTERY_SOON);
                    setPage(1);
                  }}
                  value={TABS.TAB_LOTTERY_SOON}
                  name="TAB_LOTTERY_SOON"
                >
                  販売予定
                </div>
                <div
                  className={`tab-lottery ${
                    status === TABS.TAB_LOTTERY_END && 'tab-lottery-active'
                  }`}
                  onClick={() => {
                    setStatus(TABS.TAB_LOTTERY_END);
                    setPage(1);
                  }}
                  value={TABS.TAB_LOTTERY_END}
                  name="TAB_LOTTERY_END"
                >
                  販売終了
                </div>
              </div>

              <div className="content-list">
                {dataCollection.data.length > 0 &&
                  dataCollection.data.map((collection, index) => {
                    return (
                      <Collection
                        key={index}
                        collection={collection}
                        isShowTime={true}
                        onClick={() => history.push(`/lottery/${collection.id}`)}
                      />
                    );
                  })}
              </div>
              <Pagination onChange={handleChangePage} totalPage={totalPage} forcePage={page} />
            </div>
          </>
        </>
      )}
      <ScrollButton />
    </>
  );
}

export default ListLottery;
